<ng-container *ngIf="!!page">
    <tt-card>
        <tt-input ttLabel="transportarea_name" [(ttModel)]="page.transportarea_name" ttReadonly></tt-input>
        <tt-input ttLabel="postplace_id_fom" [(ttModel)]="page.postplace_id_fom" ttRequired></tt-input>
        <tt-input ttLabel="postplace_id_tom" [(ttModel)]="page.postplace_id_tom" ttRequired></tt-input>
        <tt-button-save ttText="transportareappadd_add" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</ng-container>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="transportarea_name" tt-model="vm.model.edit.transportarea_name" tt-change="vm.model.edit.transportarea_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="postplace_id_fom" tt-model="vm.model.edit.postplace_id_fom" tt-change="vm.model.edit.postplace_id_fom = $value" tt-placeholder=""></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="postplace_id_tom" tt-model="vm.model.edit.postplace_id_tom" tt-change="vm.model.edit.postplace_id_tom = $value" tt-placeholder=""></tt-input>
        <tt-button-save class="col-xs-12 sp-0" tt-text="transportareappadd_add" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
